import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=e4b6a772"
import script from "./TitleBar.vue?vue&type=script&lang=ts"
export * from "./TitleBar.vue?vue&type=script&lang=ts"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=e4b6a772&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports